import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './input.scss';

interface Props {
  placeholder?: string;
  label?: string;
  value: string;
  min?: string;
  max?: string;
  step?: string;
  onChange: (value: string) => void;
  type?: 'timer' | 'text' | 'number' | 'text-area';
  disabled?: boolean;
  className?: string;
  isRequired?: boolean;
}

const TextInput: FC<Props> = ({
  placeholder,
  label,
  onChange,
  value = '',
  min,
  max,
  step,
  type = 'text',
  disabled = false,
  className = '',
  isRequired = false,
}) => {
  const { t } = useTranslation();

  const setText = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const renderInput = () => {
    switch (type) {
      case 'timer':
        return (
          <div className={`timer ${className}`}>
            <p>
              {label}
              {isRequired && <span className='isRequired'> *</span>}
            </p>
            <div className='timer-container'>
              <input type='number' min={min} max={max} step={step} onChange={setText} value={value} />
              <span className='unit'>{t('lblMinutes').toLowerCase()}</span>
            </div>
          </div>
        );
      case 'text':
        return (
          <div className={`input-container text ${className}`}>
            <p className={disabled ? 'disabled' : ''}>
              {label}
              {isRequired && <span className='isRequired'> *</span>}
            </p>
            <input type={type} onChange={setText} value={value} placeholder={placeholder} disabled={disabled} />
          </div>
        );
      case 'number':
        return (
          <div className={`input-container number ${className}`}>
            <p className={disabled ? 'disabled' : ''}>
              {label}
              {isRequired && <span className='isRequired'> *</span>}
            </p>
            <input type={type} onChange={setText} value={value} placeholder={placeholder} disabled={disabled} />
          </div>
        );
      case 'text-area':
        return (
          <div className={`input-container text ${className}`}>
            <p className={disabled ? 'disabled' : ''}>
              {label}
              {isRequired && <span className='isRequired'> *</span>}
            </p>
            <textarea
              onChange={event => onChange(event.target.value)}
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              rows={3}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return renderInput();
};

export default TextInput;
